import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { Box } from 'foundations-components/transitional/components/Box';
import SettingsHeader from 'settings-ui-lib/components/Header';
import Section from 'settings-ui-lib/components/Section';
import UserProfileTabs from 'settings-ui-nav/components/tab-groups/UserProfileTabs';
import LanguageContainer from '../containers/LanguageContainer';
import LocaleContainer from '../containers/LocaleContainer';
import PhoneNumberContainer from '../containers/PhoneNumberContainer';
import ProfileHeaderContainer from '../containers/ProfileHeaderContainer';
import ImpersonationAlert from './ImpersonationAlert';
import { ViewOnlyHeader } from './ViewOnlyHeader';
import AccountDefaults from './AccountDefaults';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BasicInfo = ({
  gates,
  isHubless,
  scopes,
  seatNames
}) => {
  const renderUserProfileTabs = () => {
    if (isHubless) {
      return null;
    }
    const settingsPathname = `/settings/${PortalIdParser.get()}/user-preferences/profile`;
    const showViewOnlyHeader = seatNames.includes('view-only') && scopes.includes('seats-access');
    return /*#__PURE__*/_jsx(SettingsHeader, Object.assign({
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.general"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.applyToYou"
      }),
      navigation: /*#__PURE__*/_jsx(UserProfileTabs, {
        gates: gates,
        pathname: settingsPathname
      })
    }, showViewOnlyHeader ? {
      secondaryNavigation: /*#__PURE__*/_jsx(ViewOnlyHeader, {})
    } : {}));
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [renderUserProfileTabs(), /*#__PURE__*/_jsx(Section, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.global.title"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.global.subtitle"
      }),
      marginBlockEnd: "600",
      inlineSize: "500px",
      children: /*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsx(ImpersonationAlert, {}), /*#__PURE__*/_jsx(ProfileHeaderContainer, {
          isHubless: isHubless
        }), /*#__PURE__*/_jsx(LanguageContainer, {}), /*#__PURE__*/_jsx(LocaleContainer, {}), /*#__PURE__*/_jsx(PhoneNumberContainer, {})]
      })
    }), !isHubless && /*#__PURE__*/_jsx(AccountDefaults, {})]
  });
};
export default BasicInfo;